import React from 'react';
import { compose, map, sort } from 'ramda';
import { reduxForm, InjectedFormProps, Form } from 'redux-form';
import Button from '@material-ui/core/Button';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import WizardCard from 'components/WizardCard/WizardCard';
import Fields from 'components/Fields';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import { PreviousStepType } from 'components/Wizard/Wizard';
import IntlProvider, {
  useFormatMessage,
  IntlProviderType,
  getLabelByIntlPrefix,
} from 'components/IntlProvider';

import { validate, wizardStyles } from './wizardUtils';

const { connect, selectors } = StoreProvider;

interface GenderType {
  id: number;
  value: string;
  label: string;
}

interface ProductAudienceGenderProps extends PreviousStepType {
  genders: GenderType[];
  setSubcategories: (data: object) => void;
  intl: IntlProviderType;
}

const ProductAudienceGender = ({
  handleSubmit,
  error,
  genders,
  previousStep,
}: ProductAudienceGenderProps & InjectedFormProps) => {
  const classes = wizardStyles();
  const t = useFormatMessage();
  return (
    <WizardCard>
      <Form onSubmit={handleSubmit} className={classes.form} noValidate>
        <Grid item xs={12}>
          <Typography
            component="h1"
            variant="h5"
            color="inherit"
            className={classes.title}
          >
            {t(
              'forms.wizard.productaudienceage',
              'For which target persons would you like to test your product?'
            )}
          </Typography>
          <Fields.Wizard.Gender genders={genders} />
          {error && <FormHelperText error>{error}</FormHelperText>}
          <Button
            classes={{
              root: classes.submitButton,
            }}
            type="submit"
            variant="contained"
            color="primary"
          >
            {t('fields.wizard.common.continue', 'Continue')}
          </Button>
          <Button
            onClick={previousStep}
            classes={{
              root: classes.secondaryButton,
            }}
            color="secondary"
          >
            {t('fields.wizard.common.back', 'Back')}
          </Button>
        </Grid>
      </Form>
    </WizardCard>
  );
};

export default compose(
  IntlProvider.withIntl,
  connect((state, props: ProductAudienceGenderProps) => ({
    genders: compose(
      map((gender: GenderType) => ({
        ...gender,
        value: gender.id.toString(),
        label: getLabelByIntlPrefix(gender, props.intl.locale, 'label'),
      })),
      sort((a: GenderType, b: GenderType) => a.id - b.id)
    )(selectors.assistantSelectors.genders(state)),
  })),
  reduxForm({
    form: 'wizard',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    validate,
  })
)(ProductAudienceGender);
